export default function(){
   /** @type {HTMLElement[]} */
   let scrollElements = document.querySelectorAll("[data-scroll-class]")

   window.addEventListener("scroll", ()=>{
      let scrollTop = window.scrollY;
      
      if(scrollTop > 0){
         scrollElements.forEach(element => {element.classList.toggle(element.getAttribute("data-scroll-class"), true)});
      }else{
         scrollElements.forEach(element => {element.classList.toggle(element.getAttribute("data-scroll-class"), false)});

      }
   });
}